module.exports = __webpack_public_path__ + "img/operatori.677ca025.jpeg";